import React from 'react';

import PropTypes from 'prop-types';

import './MailHotline.scss';

export const MailHotline = ({ children }) => {
  return <div className="mail-hotline">{children}</div>;
};

MailHotline.propTypes = {
  children: PropTypes.node.isRequired,
};
